import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { ConvertToFloat, isValidArray } from "../../../Layout/Common/common";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { ImageWithDefault } from "../../../Layout/Common/imageWithDefault";
import { QuantityStripper } from "../../../Layout/Common/quantityStripper";
import { ISPICKUPONLY_MESSAGE } from "../../../constants";
import { ProductLink } from "../../../Layout/Common/productLink";
import { ItemReferenceInput } from "../../../Layout/Common/itemReferenceInput";

export const QuickOrderMyCard = ({ cartItemList }) => {
  const [cartItem, setCartItem] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { handleDeleteCartItem } = useGlobalFunction();
  useEffect(() => {
    if (isValidArray(cartItemList)) setCartItem(cartItemList);
  }, [cartItemList]);
  const removeCard = (item) => {
    handleDeleteCartItem(item.prod_id, item.order_item_id);
  };

  return (
    <Fragment>
      {isValidArray(cartItem) && (
        <TransitionGroup>
          {cartItem.map((item, index) => (
            <CSSTransition key={item.prod_id} timeout={300}>
              <div className="added-cartPro" key={index} data-id={item.prod_id}>
                <div className="added-cartPro-img">
                  <ImageWithDefault src={item.image_th} alt="Product-image" />
                </div>
                <div className="added-cartPro-content">
                  <div className="added-cartPro-info quickOrder-cartpro">
                    <div className="added-cartPro-item">
                      <h6>
                        <ProductLink to={item.product_url}>{item.description}</ProductLink>
                      </h6>
                      {isValidArray(globalcontext.pickupOnlyProduct) &&
                        globalcontext.pickupOnlyProduct.includes(String(item.prod_id)) && (
                          <div className="text-danger form-validation-message">{ISPICKUPONLY_MESSAGE}</div>
                        )}
                    </div>
                    <div className="border-link">
                      <button
                        type="submit"
                        className="remove-pro-popup"
                        onClick={() => {
                          removeCard(item);
                        }}
                      >
                        <i className="fa-regular fa-trash-can" />
                      </button>
                    </div>
                  </div>
                  <div className="added-cartPro-price">
                    <div className="quickorder-price">
                      <p>${ConvertToFloat(item.total_ext)}</p>
                      <QuantityStripper
                        inline={false}
                        prd={item}
                        params={{
                          code: item.prod_code,
                          desc: item.description,
                          img: item.image_th,
                        }}
                      />
                    </div>
                    <div className="quickorder-code">
                      <p>${ConvertToFloat(item.price_ext_applied)} each</p>
                      <p className="quickorderCode">Code: {item.prod_code}</p>
                    </div>
                  </div>
                  <ItemReferenceInput item={item} />
                </div>
              </div>
            </CSSTransition>
          ))}
        </TransitionGroup>
      )}
    </Fragment>
  );
};
